import { render } from "./AboutService.vue?vue&type=template&id=6c225e6d&scoped=true"
import script from "./AboutService.vue?vue&type=script&lang=js"
export * from "./AboutService.vue?vue&type=script&lang=js"

import "./AboutService.vue?vue&type=style&index=0&id=6c225e6d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c225e6d"]])

export default __exports__